import { FC, useState } from 'react';

import PrimaryButton from 'components/FreeTrialFTUX/ui/PrimaryButton';
import StepShell from 'components/FreeTrialFTUX/ui/StepShell';

interface IntegrationStepProps {
  heading: string;
  description: string;
  question: string;
  placeholder: string;
  initialValue?: string;
  nextLabel: string;
  skipLabel: string;
  onSubmit: (value: string) => void;
  onSkip: () => void;
  isTransitioning: boolean;
}

const IntegrationStep: FC<IntegrationStepProps> = ({
  heading,
  description,
  question,
  placeholder,
  initialValue = '',
  nextLabel,
  skipLabel,
  onSubmit,
  onSkip,
  isTransitioning,
}) => {
  const [value, setValue] = useState(initialValue);

  return (
    <StepShell
      heading={heading}
      description={description}
      stepNumber={2}
      onSkip={onSkip}
      skipLabel={skipLabel}
      isTransitioning={isTransitioning}
      rightPanel={
        <div className="flex flex-col gap-3">
          <label className="font-roboto text-sm font-semibold leading-5 text-ftux-label" htmlFor="ft-integration-input">
            {question}
          </label>
          <input
            id="ft-integration-input"
            type="text"
            value={value}
            onChange={e => setValue(e.target.value)}
            placeholder={placeholder}
            className="w-full rounded-lg bg-ftux-surface p-3 font-roboto text-md text-gray-900 shadow-xs outline outline-1 outline-gray-200 placeholder:text-ftux-placeholder focus:outline-primary-300"
          />
        </div>
      }
      bottomAction={
        <PrimaryButton onClick={() => onSubmit(value)} disabled={!value.trim()}>
          {nextLabel}
        </PrimaryButton>
      }
    />
  );
};

export default IntegrationStep;
